export default "__VITE_ASSET__cp2hy_37__"